import { Dto, DtoWithId } from "@mango/core";
import { Land } from "./land";
import { Relatie } from './relatie';

@Dto({fullName: "CIJBorculo.Logic.Contactpersoon"})
export class Contactpersoon extends DtoWithId {
	oldID: number;
	relatieID: Relatie;
	naam: string;
	aanhef: string;
	titel: string;
	initialen: string;
	voornaam: string;
	tussenvoegsel: string;
	achterNaam: string;
	afdeling: string;
	functie: string;
	tel1: string;
	tel2: string;
	tel3: string;
	tel4: string;
	fax: string;
	eMail: string;
	opmerking: string;
	eMail2: string;
	actief: boolean;
	adres: string;
	postcode: string;
	plaats: string;
	land: Land;
}